<template>
  <MainWrapperDesktop disable-search>
    <template #sidebarTop>
      <DSSidebarItem
        label="Advisor"
        :icon="ChartPieIcon"
        :active="true"
        as="RouterLink"
        :to="{ name: ROUTE_NAME.ADVISOR }"
        class="w-full bg-white/10 hover:bg-white/15 border border-white/15"
      />
    </template>
    <template #repository>
      <div class="flex items-center gap-2.5 py-1.5 pr-2.5 pl-1.5">
        <span class="flex items-center justify-center size-7.5 rounded-ds-sm bg-accent text-brand shrink-0">
          <LandmarkIcon
            class="size-4"
            aria-hidden="true"
          />
        </span>
        <span class="text-[15px] font-bold text-foreground whitespace-nowrap">Advisor mode</span>
      </div>
    </template>
    <template #panel>
      <MainPanelContainer caption="All clients">
        <AdvisorClientsTree />
      </MainPanelContainer>
    </template>
    <template #content>
      <div class="-mx-6 px-6 flex-auto py-4 bg-background">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </template>
  </MainWrapperDesktop>
</template>

<script setup lang="ts">
import { ROUTE_NAME } from '@/const'

import { DSSidebarItem } from '@ds'

import AdvisorClientsTree from './components/AdvisorClientsTree.vue'
import MainPanelContainer from '../components/MainPanelContainer.vue'
import MainWrapperDesktop from '../components/MainWrapperDesktop.vue'
import { ChartPieIcon, LandmarkIcon } from '@lucide/vue'
</script>
